<div id="dashboard" class="container-fluid mt-3">
  <div class="row mt-1">
    <div class="col-12">
      <filter-table [user]="infoUserLogin.user"></filter-table>
    </div>
  </div>
  <div class="row mt-1">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <div class="float-start w-50">
            <h5 class="card-title">Lista file caricati</h5>
            <h6 class="card-subtitle text-muted">
              Ultimo aggiornamento: {{ customDateStamp(timingUpdate) }}
            </h6>
          </div>

          <button class="btn btn-secondary float-end fw-bold" (click)="generateTable()" data-bs-toggle="tooltip" data-bs-placement="top" title="Aggiorna">
            <i class="mdi mdi-update"></i><span class="d-none d-lg-inline-block">Aggiorna</span>
          </button>

          <div class="upload-btn-wrapper float-end fw-bold me-2" *ngIf="!infoUserLogin.user.isAdmin()">
            <button class="btn btn-warning fw-bold">
              <i class="dripicons-upload me-1"></i> Carica file
            </button>
            <input type="file" name="file" (change)="uploadFile($event.target)"/>
          </div>
        </div>
        <div class="card-body table-responsive">
          <div *ngIf="loadingTable" class="w-100 text-center">
            <div class="spinner-border" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
          <div *ngIf="!loadingTable && !(resultsTable && resultsTable.length)" class="alert alert-danger" role="alert">
            <strong>Attenzione!</strong> non ci sono dati presenti
          </div>
          <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="text-black table dt-responsive nowrap w-100">
            <thead>
            <tr>
              <th *ngIf="infoUserLogin.user.isAdmin()" title="Seleziona">Sel.</th>
              <th>Nome File</th>
              <th>Gruppo</th>
              <th>Tipo file</th>
              <th>Data Caricamento</th>
              <th>Stato</th>
              <th>Info</th>
              <th>File</th>
              <th *ngIf="infoUserLogin.user.isAdmin()" class="bg-secondary text-white">
                Verifica / Inserisci
              </th>
              <th class="bg-secondary text-white">
                Report Errori
              </th>
              <th *ngIf="infoUserLogin.user.isAdmin()" class="bg-secondary text-white">
                Scarta / Elimina
              </th>
            </tr>
            </thead>
            <tbody>
            <ng-container *ngFor="let file of resultsTable">
              <tr *ngIf="file && file.file_name">
                <td *ngIf="infoUserLogin.user.isAdmin()"><input type="checkbox" [attr.data-file]="file.OBJECTID"></td>
                <td class="d-block text-wrap" style="width: {{config.table.widthColumns}}px!important">{{ file.file_name }}</td>
                <td>{{ file.group_name }}</td>
                <td>{{ file.file_type }}</td>
                <td data-sort='{{convertStringToTimestamp(file.creation_date)}}'>
                  {{ convertStringToDateYYYYMMDD(file.creation_date) }}
                </td>
                <td class="text-center fw-bold text-{{foundClassStatus(file.status)}}">
                  {{ file.status }}
                </td>
                <td>
                  <button type="{{file.OBJECTID}}" class="btn btn-outline-info fileInfo" (click)="infoStatusFile(file)">
                    <i class="dripicons-information" type="{{file.OBJECTID}}"></i>
                  </button>
                </td>
                <td class="text-center">
                  <a href="{{config.microServices.pathFileTemp}}{{file.temp_file_name}}" download="{{ file.file_name }}" target="_blank" class="btn btn-info" title="Scarica file {{ file.file_name }}">
                    <i class="dripicons-download"></i> Scarica
                  </a>
                </td>
                <td *ngIf="infoUserLogin.user.isAdmin()" class="text-center">
                  <button *ngIf="controlValidateInsert(file)" (click)="startValidateInsert($event, file)" class="btn {{ file.validateInsert.class }}" title="{{ file.validateInsert.label }}">
                    <i class="{{ file.validateInsert.icon }}"></i>
                    {{ file.validateInsert.label }}
                  </button>
                </td>
                <td class="text-center">
                  <a *ngIf="controlErrorExist(file.status)" href="{{ config.microServices.pathFileTemp }}{{fileError(file)}}" download="ListaErrori_{{ file.file_name}}.xlsx" target="_blank" class="btn btn-danger" title="Scarica file errori {{ file.file_name }}">
                    <i class="dripicons-blog"></i> Scarica
                  </a>
                </td>
                <td *ngIf="infoUserLogin.user.isAdmin()" class="text-center">
                  <button *ngIf="controlTrashDelete(file)" (click)="starTrashDeleteFile($event, file)"  [attr.data-file]="file.OBJECTID" class="btn {{ file.trashDelete.class }}" title="{{ file.trashDelete.label }}">
                    <i class="{{ file.trashDelete.icon }}"></i>
                    {{ file.trashDelete.label }}
                  </button>
                </td>
              </tr>
            </ng-container>

            </tbody>
          </table>

          <div class="row" *ngIf="infoUserLogin.user.isAdmin()">
            <div class="col-12">
              <h5 class="card-title">Operazioni per selezioni multiple</h5>
            </div>
            <div class="col-md-3 mb-1">
              <button class="btn btn-outline-warning w-100" (click)="multipleVerify()">
                <i class="dripicons-search me-1"></i> Verifica multipla
              </button>
            </div>
            <div class="col-md-3 mb-1">
              <button class="btn btn-outline-success w-100" (click)="multipleInsert()">
                <i class="dripicons-cloud-upload me-1"></i> Inserimento multiplo
              </button>
            </div>
            <div class="col-md-3 mb-1">
              <button class="btn btn-danger w-100" (click)="multipleTrash()">
                <i class="dripicons-trash me-1"></i> Scarto multiplo
              </button>
            </div>
            <div class="col-md-3 mb-1">
              <button class="btn btn-outline-danger w-100" (click)="multipleDelete()">
                <i class="dripicons-document-delete me-1"></i> Eliminazione multipla
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="loadingModal" class="position-fixed bg-secondary bgLoading" role="status">
  <div class="spinner-border m-5" role="status">
  </div>
</div>

<div *ngIf="elementSelect" id="detailsStatus" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="standard-modalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title" id="standard-modalLabel">
          Dettagli stato {{ elementSelect.file.file_name }}
        </h4>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-hidden="true"
        ></button>
      </div>
      <div class="modal-body">
        <div class="timeline-alt pb-0">
          <div class="timeline-item" *ngFor="let status of elementSelect.listStatus">
            <i class="mdi mdi-circle bg-{{foundClassStatus(status.status)}}-lighten timeline-icon text-{{foundClassStatus(status.status)}}"></i>
            <div class="timeline-item-info">
              <span class="text-{{foundClassStatus(status.status)}} fw-bold mb-1 d-block">{{ status.status }}</span>
              <p class="mb-0 pb-2">
                <small class="text-muted">{{ status.status_date }}</small>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-light" data-bs-dismiss="modal">
          Chiudi
        </button>
      </div>
    </div>
  </div>
</div>

<div id="success-alert-modal" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-sm">
    <div class="modal-content modal-filled bg-success">
      <div class="modal-body p-4">
        <div class="text-center">
          <i class="dripicons-checkmark h1"></i>
          <h4 class="mt-2">File Caricato!</h4>
          <p class="mt-3">Il tuo file è stato caricato con successo</p>
          <button type="button" class="btn btn-light my-2" data-bs-dismiss="modal">
            Continua
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<div id="warning-alert-modal" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-sm">
    <div class="modal-content">
      <div class="modal-body p-4">
        <div class="text-center">
          <i class="dripicons-warning h1 text-warning"></i>
          <h4 class="mt-2">Attenzione</h4>
          <p class="mt-3">{{ textErrorUpload }}</p>
          <button type="button" class="btn btn-warning my-2" data-bs-dismiss="modal">
            Continua
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
